import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Tailwind 클래스 충돌 없이 병합
 * 예: cn('px-2 py-1', condition && 'bg-blue-500', 'px-4') → 'py-1 bg-blue-500 px-4'
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
